export const getStartDateString = (startDate: string) => {
  const date = new Date(startDate);
  const monthPart = `0${date.getMonth() + 1}`.slice(-2);
  return `${date.getFullYear()}-${monthPart}-01`;
};
